import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./EditarAcao.css";

function EditarAcao() {
    const { acaoId } = useParams();
    console.log("ID da ação recebido:", acaoId);

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        descricao: "",
        data_acao: "",
        objecao: "",
        lead_nome: "", // Armazena o nome do lead
    });

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchAcao();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchAcao = async () => {
        try {
            console.log("🔄 Buscando dados da ação...");

            const response = await fetch(`https://welaunchyou.com.br/crm-wly/editar_acao.php?id=${acaoId}`, {
                credentials: "include",
            });

            const data = await response.json();
            console.log("✅ Dados da ação recebidos:", data);

            if (data.acao) {
                setFormData({
                    descricao: data.acao.descricao,
                    data_acao: data.acao.data_acao,
                    objecao: data.acao.objecao || "",
                    lead_nome: data.acao.lead_nome || "", // Captura o nome do lead
                });
            } else {
                setError("Ação não encontrada.");
            }
        } catch (err) {
            console.error("❌ Erro ao buscar ação:", err);
            setError("Erro ao buscar a ação.");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        setError("");

        console.log("🚀 Enviando edição com dados:", formData);

        try {
            const response = await fetch("https://welaunchyou.com.br/crm-wly/editar_acao.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    acao_id: acaoId,
                    descricao: formData.descricao,
                    data_acao: formData.data_acao,
                    objecao: formData.objecao || null, // Enviar `null` caso não tenha objeção
                }),
            });

            const data = await response.json();
            console.log("📩 Resposta do servidor:", data);

            if (response.ok) {
                setMessage("Ação atualizada com sucesso!");
                setTimeout(() => navigate("/acoes"), 2000);
            } else {
                setError(data.error || "Erro ao editar ação.");
            }
        } catch (err) {
            console.error("❌ Erro ao conectar ao servidor:", err);
            setError("Erro ao conectar ao servidor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="editar-acao-container">
            <h1>Editar Ação</h1>

            {message && <p className="success-message">{message}</p>}
            {error && <p className="error-message">{error}</p>}

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="lead_nome">Nome do Lead:</label>
                    <input
                        type="text"
                        id="lead_nome"
                        name="lead_nome"
                        value={formData.lead_nome}
                        readOnly // Nome do lead apenas para exibição
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="descricao">Descrição:</label>
                    <textarea
                        id="descricao"
                        name="descricao"
                        value={formData.descricao}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="data_acao">Data da Ação:</label>
                    <input
                        type="date"
                        id="data_acao"
                        name="data_acao"
                        value={formData.data_acao}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="objecao">Objeção (Opcional):</label>
                    <select id="objecao" name="objecao" value={formData.objecao} onChange={handleChange}>
                        <option value="">Selecione uma objeção</option>
                        <option value="Sem orçamento">Sem orçamento</option>
                        <option value="Não tem interesse no momento">Não tem interesse no momento</option>
                        <option value="Decisão adiada">Decisão adiada</option>
                        <option value="Achou complexo">Achou complexo</option>
                        <option value="Optou por concorrente">Optou por concorrente</option>
                        <option value="Preço elevado">Preço elevado</option>
                        <option value="Sem tempo">Sem tempo</option>
                    </select>
                </div>

                <button type="submit" disabled={loading}>{loading ? "Salvando..." : "Salvar"}</button>
             </form>
        </div>
    );
}

export default EditarAcao;
